import * as React from 'react'

import { RenderButton } from '../../atoms/Button/RenderButton'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
}

/**
 * Forms and Transactions Component
 * @param content - Content from the CMS.
 */
const FormsAndTransactions = ({ content }: Props) => {
  const formatFileSize = (bytes: number) => {
    if (bytes === 0) return '0 B'
    if (isNaN(bytes)) return 'N/A'
    const units = ['B', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    const size = bytes / Math.pow(1024, i)
    return `${size.toFixed(0)}${units[i]}`
  }

  const getExtensionLabel = (mimeType: string | null | undefined) => {
    if (!mimeType || !mimeType.includes('/')) return 'FILE'
    const ext = mimeType.split('/')[1] // "pdf", "jpeg", "png", etc.
    return ext.toUpperCase()
  }

  return (
    <>
      <div className="layoutSpacing">
        <div data-testid="formsAndTransactions" className="sectionBottomSpacing layout w-100">
          {content?.subheadline && content?.headline && (
            <Headings variant="H2" content={content?.headline} classes="text-purple-100 !pb-24" />
          )}
          {content?.description && <Paragraph content={content?.description} classes="pb-16" />}
          <div className="overflow-hidden rounded-2xl border border-neutral-50">
            <Headings
              variant="H4"
              content={content?.subheadline ? content?.subheadline : content?.headline}
              classes="bg-purple-100 text-white !p-32"
            />
            {content?.features?.map((item) => {
              const assetData = item?.fields?.downloadButton?.fields?.assetReference?.fields
              const title = assetData
                ? `<span>${assetData.title} <span class='hidden md:inline !font-normal text-neutral-90'>(${getExtensionLabel(assetData.file.contentType)} ${formatFileSize(assetData.file.details.size)})</span></span>`
                : item?.fields?.headingName

              return (
                <div
                  key={item?.sys?.id}
                  className="border-bg-neutral-50 flex flex-col items-start justify-between gap-24 border-b px-32 py-24 xl:flex-row xl:items-center"
                >
                  <div className="flex flex-col items-start gap-24 xl:flex-row xl:items-center xl:gap-32">
                    <Image
                      imageUrl={item?.fields?.cardImage?.fields?.file?.url}
                      altText={item?.fields?.headingName}
                      height="56"
                    />
                    <div>
                      <Paragraph content={title} classes="font-semibold mb-2 md:mb-8" />
                      {assetData && <Paragraph content={`(${getExtensionLabel(assetData.file.contentType)} ${formatFileSize(assetData.file.details.size)})`} classes="md:hidden md:inline !font-normal text-neutral-90 mb-2" />}
                      <Paragraph
                        content={assetData ? assetData.description : item?.fields?.description}
                        classes="!text-base"
                      />
                    </div>
                  </div>
                  <div>
                    <RenderButton item={item?.fields?.downloadButton} underline />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default FormsAndTransactions
